import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { CheckboxGroupComponent, CheckboxOption } from '../checkbox-group/checkbox-group.component';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-checkbox-group',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, CheckboxGroupComponent],
  template: `
    <app-checkbox-group
      [formControl]="formControl"
      [options]="checkboxOptions()"
      [cols]="3" />
  `
})
export class CheckboxGroupFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }

  checkboxOptions(): CheckboxOption[] {
    return (this.config.options ? this.config.options() : []) as CheckboxOption[];
  }
}
